// Add genuine client testimonials here as { quote, name, role } objects.
// The testimonials section renders only when this list is non-empty —
// no placeholders or fabricated quotes are ever shown.
export const TESTIMONIALS = [];
